import { Component, OnInit } from '@angular/core';
import { Client } from '../_shared/models/client';
import { ClientApplicationService } from '../_shared/services/client-application.service';
import { ClientSettingsService } from '../_shared/services/client-settings.service';
import { Router, RouterOutlet } from '@angular/router';
import { first } from 'rxjs';

@Component({
    selector: 'app-ad-hoc-layout',
    templateUrl: './ad-hoc-layout.component.html',
    standalone: true,
    imports: [RouterOutlet],
})
export class AdHocLayoutComponent implements OnInit {
    applicationId!: string;

    client!: Client;

    constructor(
        private applicationService: ClientApplicationService,
        private clientService: ClientSettingsService,
        private router: Router,
    ) {
        /** TODO - figure out if these are used / why they are here */
        this.router.events.pipe(first()).subscribe((event: any) => {
            if (event.snapshot) {
                const currentRoute = event.snapshot.url;
                if (currentRoute?.length) {
                    // No Property lookup here (RF-3022): apply links carry a UNIT id in
                    // the `:propertyId` slot, and ApplyComponent reads that unit itself
                    // (GET /units/public/{id}). Looking it up as a Property 404'd on
                    // every apply page and was never rendered.
                    this.applicationId = event.snapshot.params.applicationId;
                    if (this.applicationId) {
                        this.getApplication();
                    }
                }
            }
        });
    }

    ngOnInit(): void {}

    /** TODO - figure out if these are used / why they are here */
    getApplication() {
        this.applicationService
            .getApplicationFormToFillOut(this.applicationId)
            .subscribe((application) => {
                this.clientService
                    .getClientBasic(application.clientId)
                    .subscribe((res) => {
                        this.client = res;
                    });
            });
    }
}
